import React from 'react';
import { X, Upload, Loader2, Palette } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { resolveAssetUrl } from '@/lib/assetUrl';

export const ColorAndLogoSection = ({
  brandingData, setBrandingData, logoFileRef, uploadingLogo, onLogoUpload,
  detectingColor, onDetectColor
}) => (
  <>
    <div>
      <Label htmlFor="primary_color">Cor Principal</Label>
      <div className="flex gap-2 mt-1">
        <input
          type="color"
          id="primary_color"
          value={brandingData.primary_color}
          onChange={(e) => setBrandingData(prev => ({ ...prev, primary_color: e.target.value }))}
          className="w-10 h-10 rounded border cursor-pointer"
        />
        <Input
          value={brandingData.primary_color}
          onChange={(e) => setBrandingData(prev => ({ ...prev, primary_color: e.target.value }))}
          placeholder="#0F172A"
          className="w-32"
        />
      </div>
    </div>

    <div>
      <Label htmlFor="website_url">URL do Site — detetar a cor principal automaticamente</Label>
      <div className="flex gap-2 mt-1">
        <Input
          id="website_url"
          value={brandingData.website_url}
          onChange={(e) => setBrandingData(prev => ({ ...prev, website_url: e.target.value }))}
          placeholder="https://empresa.com"
          data-testid="website-url-input"
        />
        <Button
          variant="outline"
          onClick={onDetectColor}
          disabled={detectingColor || !brandingData.website_url}
          data-testid="detect-color-btn"
          className="whitespace-nowrap"
        >
          {detectingColor ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Palette className="w-4 h-4 mr-2" />}
          {detectingColor ? 'A detetar...' : 'Detetar Cor'}
        </Button>
      </div>
      <p className="text-sm text-slate-500 mt-1">Lê a "theme-color" do site e, se não existir, a cor dominante do favicon.</p>
    </div>

    <div>
      <Label htmlFor="company_logo_url">Logo da Empresa — aparece no canto superior direito</Label>
      <div className="mt-2 space-y-3">
        {brandingData.company_logo_url && (
          <div className="flex items-center gap-3 p-3 bg-white border border-slate-200 rounded-lg w-fit">
            <img
              src={resolveAssetUrl(brandingData.company_logo_url)}
              alt="Logo preview"
              className="max-h-12 w-auto object-contain"
            />
            <button
              onClick={() => setBrandingData(prev => ({ ...prev, company_logo_url: '' }))}
              className="p-1 text-slate-400 hover:text-red-600"
              title="Remover logo"
              data-testid="remove-logo-btn"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        )}
        <div className="flex gap-2 items-center">
          <input type="file" ref={logoFileRef} onChange={onLogoUpload} accept="image/*" className="hidden" data-testid="logo-file-input" />
          <Button
            variant="outline"
            onClick={() => logoFileRef.current?.click()}
            disabled={uploadingLogo}
            data-testid="upload-logo-btn"
          >
            {uploadingLogo ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
            {uploadingLogo ? 'A carregar...' : 'Carregar Logo'}
          </Button>
          <span className="text-xs text-slate-400">ou cole um URL abaixo</span>
        </div>
        <Input
          id="company_logo_url"
          value={brandingData.company_logo_url}
          onChange={(e) => setBrandingData(prev => ({ ...prev, company_logo_url: e.target.value }))}
          placeholder="https://empresa.com/logo.png"
          data-testid="company-logo-url-input"
        />
        <p className="text-sm text-slate-500">PNG, JPEG, WebP ou SVG, máximo 2MB</p>
      </div>
    </div>
  </>
);
